import React, { useEffect, useState, useRef } from 'react'
// import { useParams } from 'react-router-dom'
// import { DataTable } from 'choice-tables'
import { Checkbox } from 'semantic-ui-react'
import { post } from '../../utils/apiClient'
import { formatDate } from '../../utils/formatDate'
import { FormMessage } from 'choice-forms'
import { htmlToReactWithReplace } from '../../utils/html'
import SignatureCanvas from 'react-signature-canvas'
import { Button } from 'semantic-ui-react'

export default function ClientViewBid({ clientBid, viewBid }) {
  // const params = useParams()
  const signatureRef = useRef(null)
  const [state, setState] = useState({
    bid: {},
    viewBid: {},
    isAccepted: false,
    isProcessing: false,
    isEditable: true,
    formMessage: '',
    signature: null,
    responseDate: null
  })

  const changeSelected = ({ uid }) => {
    setState((prevState) => {
      const { bid } = prevState
      const bidItemIndex = bid.bid_items.findIndex((item) => item.uid === uid)
      if (
        bid.bid_items[bidItemIndex].is_selected &&
        bid.bid_items[bidItemIndex].option_group_name
      ) {
        return prevState
      }
      if (bid.bid_items[bidItemIndex].option_group_name) {
        const optionGroupName = bid.bid_items[bidItemIndex].option_group_name
        bid.bid_items = bid.bid_items.map((item) => {
          if (item.option_group_name === optionGroupName) {
            return { ...item, is_selected: false }
          }
          return item
        })
      }
      bid.bid_items[bidItemIndex].is_selected = bid.bid_items[bidItemIndex]
        .is_selected
        ? false
        : true

      return {
        ...prevState,
        bid,
        viewClientBid: htmlToReactWithReplace(
          prevState.viewBid,
          bid,
          changeSelected
        )
      }
    })
  }

  const mount = () => {
    async function fetchData() {
      if (clientBid) {
        setState({
          ...state,
          bid: clientBid,
          viewBid: viewBid,
          viewClientBid: htmlToReactWithReplace(
            viewBid,
            clientBid,
            changeSelected
          ),
          isAccepted: clientBid.is_accepted ? true : false,
          signature: clientBid.signature ?? null,
          isEditable: clientBid.response_datetime ? false : true
        })
        return
      }
      // })
      // if (res) {
      //   setState({
      //     ...state,
      //     loading_search: false,
      //     bid: res.bid ? res.bid : {},
      //     viewBid: htmlToReactWithReplace(res.viewBid),
      //     isAccepted: res.bid?.is_accepted ? true : false,
      //     signature: res.bid?.signature ?? null,
      //     isEditable: res.bid?.response_datetime ? false : true
      //   })
      // }
    }
    fetchData()
    window.scrollTo(0, 0)
    const unmount = () => post.completeRequest(false)
    return unmount
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(mount, [])

  const saveSignature = () => {
    // const image = signatureRef.current.getTrimmedCanvas().toDataURL()
    const image = signatureRef.current.toDataURL() // setSignatureImage(image)
    if (!signatureRef.current.isEmpty()) {
      setState({ ...state, signature: image, formMessage: '' })
    }
  }
  // const loadSignature = () => {
  //   const { signature } = state
  //   signatureRef.current.fromDataURL(signature)
  //   // const image = signatureRef.current.getTrimmedCanvas().toDataURL()
  //   // signatureRef.current.off()
  // }
  const clearSignature = () => {
    signatureRef.current.clear()
  }

  const submitBid = async () => {
    const { isProcessing, bid, isAccepted, signature } = state
    if (isProcessing) {
      return
    }
    const errors = []

    if (!isAccepted) {
      errors.push({
        message: 'Please accept by checking the box above.'
      })
    }
    if (!signature || signatureRef.current.isEmpty()) {
      errors.push({
        message: 'Please sign and accept your signature.'
      })
    }

    if (errors.length > 0) {
      setState({
        ...state,
        formMessage: {
          errors
        }
      })
    } else {
      setState({ ...state, isProcessing: true })
      const res = await post('/api/view/submit-bid', {
        data: { bid, isAccepted, signature }
      })
      let isEditable = true
      let responseDate = null
      let updatedBid

      setState((prevState) => {
        if (res.ok === true) {
          isEditable = false
          responseDate = new Date()
          updatedBid = {
            bid: res.bid,
            viewClientBid: htmlToReactWithReplace(
              prevState.viewBid,
              res.bid,
              changeSelected
            )
          }
        }
        return {
          ...prevState,
          isProcessing: false,
          isEditable,
          responseDate,
          formMessage: res,
          ...updatedBid
        }
      })
    }
  }
  const checkboxLabel =
    'I accept this quote and agree to the terms and conditions.'

  const { signature, isEditable } = state
  if (isEditable) {
    return (
      <div className="mb-5">
        {state.viewClientBid}
        <Checkbox
          className="mt-4 mb-4"
          onClick={() =>
            setState({
              ...state,
              isAccepted: !state.isAccepted,
              formMessage: ''
            })
          }
          checked={state.isAccepted ? true : false}
          label={checkboxLabel}
        />
        <div style={{ border: '1px solid #ddd' }} className="mb-5">
          <div style={{ display: signature ? 'none' : 'block' }}>
            <SignatureCanvas
              ref={signatureRef}
              clearOnResize={false}
              canvasProps={{
                style: { width: '100%', minHeight: 100 },
                className: 'signature-pad'
              }}
            />
            <Button color={'grey'} onClick={() => saveSignature()}>
              Accept
            </Button>
            <Button color={'grey'} onClick={() => clearSignature()}>
              Clear
            </Button>
          </div>
          {signature ? (
            <div
              style={{ maxHeight: '100px' }}
              onClick={() => setState({ ...state, signature: '' })}>
              <img style={{ maxHeight: '100px' }} src={signature} />
            </div>
          ) : (
            ''
          )}
        </div>
        {state.formMessage && <FormMessage {...state.formMessage} />}
        <Button
          className="mb-5"
          size="large"
          color="green"
          loading={state.isProcessing}
          onClick={() => submitBid()}
          content="Submit"
        />
        <Button
          className="ml-4"
          icon="file pdf"
          content="PDF"
          as="a"
          text="Bid"
          href={`/files/pdf/bid/${state.uid}`}
          target="_blank"
          rel="noopener noreferrer"
        />
      </div>
    )
  }
  return (
    <div className="mb-5">
      {state.viewClientBid}
      <Checkbox
        className="mt-4 mb-4 default-cursor"
        checked={state.isAccepted ? true : false}
        label={checkboxLabel}
      />
      <div style={{ borderBottom: '1px solid #ddd' }} className="mb-3">
        <div style={{ maxHeight: '100px' }}>
          <img style={{ maxHeight: '100px' }} src={signature} />
        </div>
      </div>
      <div className="mb-5" style={{ fontSize: '.7em' }}>
        {formatDate(
          state.bid?.response_datetime ?? state.responseDate,
          'mm/dd/yyyy'
        )}
      </div>
      {state.formMessage && <FormMessage {...state.formMessage} />}
      <Button
        className="ml-4"
        icon="file pdf"
        content="PDF"
        as="a"
        text="Bid"
        href={`/files/pdf/bid/${state.uid}`}
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>
  )
}
